import colors from 'vuetify/lib/util/colors';

export const themeColors = {
  default: {
    primary: '#6495ED', // pastel blue
    secondary: '#4A148C', // dark purple
    accent: '#FFA07A', // light salmon
    'bg-dark': colors.grey.darken4,
    'bg-grey': colors.blueGrey.darken2,
    'bg-light': colors.grey.lighten2,
  },
  summer: {
    primary: '#F39C12', // orange
    secondary: '#5DADE2', // pastel blue
    accent: '#F8C471', // beige
    'bg-dark': colors.grey.darken4,
    'bg-grey': colors.blueGrey.darken2,
    'bg-light': colors.grey.lighten2,
  },
};
